/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // init controller
        var controller = new ScrollMagic.Controller();

        $('.fade').each(function() {
          var _self = this;
          var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.9,
            reverse: false
          })
          .setClassToggle(this, "in")
          .addTo(controller);
        });

        if ( $(window).width() > 600 ) {
          var slideParallaxScene = new ScrollMagic.Scene({
            triggerElement: '.js-bg-parallax',
            triggerHook: 1,
            duration: '200%'
          })
          .setTween(TweenMax.from('.section__bg-parallax', 1, {y: '-50%', ease:Power0.easeNone}))
          .addTo(controller);
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // header
        // mobile menu button
        $('.menu-toggle').on('click', function() {
          $(this).toggleClass('opened');
        });

        // close mobile menu on click
        $(document).on('click', function(e) {
          if ( !$('.menu-toggle.opened').length ) {
            return;
          }
          if ( !$(e.target).closest('.menu-toggle').length ) {
            $('.menu-toggle').removeClass('opened');
          }
        });

        var isHeaderMobile = $(window).width() < 991;
        var isHeaderTransparent = !( isHeaderMobile || $(document).scrollTop() > 300 );

        // add desktop header class
        function toogleHeaderTransparent() {
          if (!isHeaderMobile && isHeaderTransparent) {
            $('.header').addClass('header_transparent');
          } else {
            $('.header').removeClass('header_transparent');
          }
        }

        isHeaderTransparent && toogleHeaderTransparent();

        // on window resize
        $(window).on('resize', function() {
          if ( $(window).width() > 991 ) {
            isHeaderMobile = false;
            toogleHeaderTransparent();
          } else {
            isHeaderMobile = true;
            toogleHeaderTransparent();
          }
        });

        $(document).on('scroll', function() {
          if (isHeaderMobile) return;
          if (isHeaderTransparent) {
            if ( $(document).scrollTop() > 300 ) {
              isHeaderTransparent = false;
              toogleHeaderTransparent();
            }
          } else {
            if ( $(document).scrollTop() < 100 ) {
              isHeaderTransparent = true;
              toogleHeaderTransparent();
            }
          }
        });

        // smooth scroll to anchors
        $('a[href*="#"]:not([href="#"])').on('click', function() {
          if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 600);
              $('.menu-toggle').removeClass('opened');
              return false;
            }
          }
        });

        // Form ajax
        $(document).on('submit', '#contactForm', function(e) {
          e.preventDefault();
          var nameInput = $('#nameInput'),
              emailInput = $('#emailInput'),
              aboutInput = $('#aboutInput'),
              textInput = $('#textInput');

          var emailInputReg = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';

          if (nameInput.val().length < 2) {
              nameInput.addClass('input_has_error');
              nameInput.focus();
              return;
          } else {
              nameInput.removeClass('input_has_error');
          }

          if (!emailInput.val().match(emailInputReg)) {
              emailInput.addClass('input_has_error');
              emailInput.focus();
              return;
          } else {
              emailInput.removeClass('input_has_error');
          }

          if (textInput.val().length < 5) {
              textInput.addClass('input_has_error');
              textInput.focus();
              return;
          } else {
              textInput.removeClass('input_has_error');
          }

          var formObj = {
            action:           'ot_submit_form',
            name:             nameInput.val(),
            email:            emailInput.val(),
            about:            aboutInput.val(),
            text:             textInput.val(),
          };

          $.post( myajax.url, formObj, function(resp) {
            if (resp.status == 2) {
              $('#contactForm').find('.input').val('');
              $('#contactForm').find('[type="submit"]').hide();
              $('#contactFormStatus').show();
            }
          });
        });

        // Slider
        function Slider(selector, interval, speed, pauseOnHover, copies) {
          var __self = this;

          var sliderNode        = document.querySelector(selector),
              sliderImagesNode  = sliderNode.querySelector('ul'),
              prevButton        = sliderNode.querySelector('.prev'),
              nextButton        = sliderNode.querySelector('.next'),
              copiesCount       = copies || 1;

          for (var i = 0; i < copiesCount; i++) {
            sliderImagesNode.appendChild(sliderImagesNode.children[i].cloneNode(true));
          }

          var currentSlideIndex = 0,
              imagesCount       = sliderImagesNode.children.length,
              slideSize         = sliderImagesNode.children[0].offsetWidth,
              sliderInterval    = interval || 5000,
              sliderSpeed       = speed || 1000,
              slideTransition   = 'left '+ speed / 1000 + 's',
              isMoving          = false,
              pauseOnHover      = pauseOnHover || false,
              sliderTimer       = null;

          __self.prevSlide = function() {
            isMoving = true;
            if (currentSlideIndex === 0) {
              currentSlideIndex = imagesCount - copiesCount;
              sliderImagesNode.style.left = -(slideSize * currentSlideIndex) + 'px';
            }

            sliderImagesNode.style.transition = slideTransition;
            currentSlideIndex--;
          };

          __self.nextSlide = function() {
            isMoving = true;
            if (currentSlideIndex === imagesCount - 1 - copiesCount) {
              setTimeout(function() {
                sliderImagesNode.style.transition = '';
                currentSlideIndex = 0;
                sliderImagesNode.style.left = '0px';
              }, sliderSpeed);
            }

            sliderImagesNode.style.transition = slideTransition;
            currentSlideIndex++;
          };

          __self.__render = function() {
            setTimeout(function() {
              sliderImagesNode.style.transition = '';
              isMoving = false;
            }, sliderSpeed);
            sliderImagesNode.style.left = -(slideSize * currentSlideIndex) + 'px';
          };

          if (prevButton) {
            prevButton.addEventListener('click', function() {
              if (isMoving) return;
              __self.prevSlide();
              __self.__render();
            });
          }

          if (nextButton) {
            nextButton.addEventListener('click', function() {
              if (isMoving) return;
              __self.nextSlide();
              __self.__render();
            });
          }

          __self.update = function() {
            slideSize = sliderImagesNode.children[0].offsetWidth;
            sliderImagesNode.style.left = -(slideSize * currentSlideIndex) + 'px';
          };

          if (pauseOnHover) {
            sliderNode.addEventListener('mouseenter', function() {
              clearInterval(sliderTimer);
            });
            sliderNode.addEventListener('mouseleave', function() {
              __self.autoSlide();
            });
          }

          __self.autoSlide = function() {
            sliderTimer = setInterval(function() {
              __self.nextSlide();
              __self.__render();
            }, sliderInterval);
          }

          $(window).on('resize', function() {
            __self.update();
          });

          __self.autoSlide();
        }

        function heroSliderInit() {
            new Slider('.slider.hero-slider', 10000, 1200);
        }

        new Slider('.testimonial-slider', 8000, 1200, true, 3);

        $(".slider__image").Lazy({
            delay: 10,
            onFinishedAll: function() {
                heroSliderInit();
            }
        });

        // for other images
        $(".lazy").Lazy();

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

        // Lazy images
        // for main slider
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
